<template>
  <g id="f748c162-1054-49d5-88fa-e7e485b1756b" data-name="map">
    <polygon
      id="a8339c67-d008-4748-9e37-d32625bcfa98"
      :data-name="$t('aoba_ku')"
      points="114.5 159.5 450.5 14 578 77 440 336.5 129.5 324.5 114.5 159.5"
      fill="#f9c"
      class="map-presentation"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(26) ? '' : '#696969 !important',
      }"
      @click="changeAreaValue()"
    />
    <polygon
      id="bd80328e-1e5e-4500-90bb-929a6bac51b1"
      :data-name="$t('tsuzuki_ku')"
      points="440 336.5 578 77 798.5 158 755 434 644.465 461.849 473.401 475.489 440 336.5"
      fill="#f7931e"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(27) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="ee5d16c2-094f-4175-85e3-96cce6409a20"
      :data-name="$t('kohoku_ku')"
      points="798.5 158 1022 169.25 957.375 505.86 918.5 588.5 789.5 588.5 641 515 644.465 461.849 755 434 798.5 158"
      fill="#0af"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(18) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="ffcb7000-a731-4feb-a771-b86dbb55ea7f"
      :data-name="$t('midori_ku')"
      points="644.465 461.849 641 515 555.678 573.118 143.019 576.5 112.451 505.86 84 412.596 129.5 324.5 440 336.5 473.401 475.489 644.465 461.849"
      fill="#9c3"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(22) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="e87e5441-3268-456f-80ea-34c99adc478a"
      :data-name="$t('asahi_ku')"
      points="143.019 576.5 478.339 573.118 506.657 776.75 428.477 876.38 279.5 891.5 143.019 576.5"
      fill="#525fff"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(21) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="b34c8b54-92e3-43bd-ac36-ac83472fed53"
      :data-name="$t('hodogaya_ku')"
      points="478.339 573.118 506.657 776.75 428.477 876.38 555.678 965.243 756.138 917.266 737.644 694.844 555.678 573.118 478.339 573.118"
      fill="#e849b7"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(15) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="bd99d4b5-6a3b-43bb-96fd-50c91623c18b"
      :data-name="$t('kanagawa_ku')"
      points="737.644 694.844 957.375 763.333 1081 620 957.375 505.86 918.5 588.5 789.5 588.5 641 515 555.678 573.118 737.644 694.844"
      fill="#f66"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(10) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="f0e86a9c-a3bc-41ac-aa25-5b74e3da04ab"
      :data-name="$t('nishi_ku')"
      points="737.644 694.844 957.375 763.333 877.334 933.209 756.138 917.266 737.644 694.844"
      fill="#fbb03b"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(11) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="bc41bbfb-f7ca-4115-807b-dd270d641a06"
      :data-name="$t('minami_ku')"
      points="737.644 1145.5 904.437 1002.875 877.334 933.209 756.138 917.266 555.678 965.243 573.143 1078.944 737.644 1145.5"
      fill="#c7b299"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(12) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="aa2f946d-6d9b-428a-ae80-f9c383dadf45"
      :data-name="$t('naka_ku')"
      points="943 1102 877.334 933.209 915.819 851.035 1194.544 948.179 1166.011 1215.5 943 1102"
      fill="#00a99d"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(13) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="b97ffb7b-cace-4877-b2cf-2ef6f7abbe3f"
      :data-name="$t('tsurumi_ku')"
      points="957.375 505.86 988.5 338.5 1119.315 314.004 1292.5 599.5 1172.305 663.132 1081 620 957.375 505.86"
      fill="#6c6"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(14) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a4812cd6-474d-49e5-a309-70a21b8826b4"
      :data-name="$t('konan_ku')"
      points="440 1262.808 479 1037.562 565.076 1026.424 573.143 1078.944 737.644 1145.5 665.645 1420 440 1262.808"
      fill="#4d9be2"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(20) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a83ee140-cc47-4384-b213-e4c10cdd84da"
      :data-name="$t('tozuka_ku')"
      points="279.5 891.5 428.477 876.38 555.678 965.243 565.076 1026.424 479 1037.562 440 1262.808 281 1406.5 94.348 1259.848 301.436 1094.5 279.5 891.5"
      fill="#36b236"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(19) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="e04c9d6d-c882-405a-a1a8-9e9d80c91bec"
      :data-name="$t('seya_ku')"
      points="12.5 557.5 112.451 505.86 279.5 891.5 48.5 938.244 12.5 557.5"
      fill="#af7b6b"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(23) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="ae08241d-ba60-4552-96f5-4a11f21fe0fb"
      :data-name="$t('izumi_ku')"
      points="48.5 938.244 94.348 1259.848 301.436 1094.5 279.5 891.5 48.5 938.244"
      fill="#29b5cc"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(25) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a32610d0-57fc-4bcf-aa92-185e8456eeba"
      :data-name="$t('sakae_ku')"
      points="281 1406.5 440 1262.808 665.645 1420 619.25 1586.5 281 1406.5"
      fill="#e2664d"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(24) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="b6b40864-6a87-48be-bf14-7607fc239cce"
      :data-name="$t('isogo_ku')"
      points="649.459 1478.09 737.644 1145.5 904.437 1002.875 943 1102 932.669 1243 855.5 1420 649.459 1478.09"
      fill="#d1cc26"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(16) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
    <polygon
      id="a702f6c3-fa7a-414e-ae5a-8d967decc01d"
      :data-name="$t('kanazawa_ku')"
      points="649.459 1478.09 619.25 1586.5 798.333 1693.667 982.124 1547.5 989.845 1364.5 932.669 1243 855.5 1420 649.459 1478.09"
      fill="#69c"
      :style="{
        fill:
          !shopMapIds || shopMapIds.includes(17) ? '' : '#696969 !important',
      }"
      class="map-presentation"
    />
  </g>
</template>

<script>
export default {
  components: {},
  props: ['shopMapIds'],
  data: () => ({}),
  computed: {},
  created: function() {},
  mounted: function() {},
  methods: {
    changeAreaValue: function() {},
  },
};
</script>

<style scoped>
.map-presentation {
  stroke: #fff;
  stroke-linejoin: round;
  stroke-width: 8px;
}
</style>
